import React from "react";
import { Button, Col, Row } from "antd";
import CustomModal from "./Modals/CustomModal";
import PremierPlusBinDTO from "src/models/PremierPlusBinDTO";
import PlenumTempInfoContent from "./PlenumTempInfoContent";

interface PlenumTempInfoModalProps {
    show: boolean;
    onClose: () => void;
    binDto: PremierPlusBinDTO | null | undefined;
    parentRef?: React.RefObject<HTMLElement>;
}

const PlenumTempInfoModal: React.FC<PlenumTempInfoModalProps> = ({ show, onClose, binDto, parentRef }) => {
    return (
        <CustomModal
            show={show}
            onClose={onClose}
            title="INDIVIDUAL PLENUM TEMP INFO"
            parentRef={parentRef}
        >
            <Row justify="center">
                <Col span={18}>
                    <PlenumTempInfoContent binDto={binDto} />
                    <br />
                    <Row justify="end">
                        <Col span={8}>
                            <Button onClick={onClose} block type="primary">CLOSE</Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </CustomModal>
    );
};

export default PlenumTempInfoModal;
